"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSizes = void 0;
var ModalSizes;
(function (ModalSizes) {
    ModalSizes["SMALL"] = "sm";
    ModalSizes["MEDIUM"] = "md";
    ModalSizes["LARGE"] = "lg";
    ModalSizes["FULL_SCREEN"] = "fullscreen";
})(ModalSizes = exports.ModalSizes || (exports.ModalSizes = {}));
//# sourceMappingURL=ModalProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Modal/ModalProps.js
// module id = 24
// module chunks = 8